<template>
  <div v-if="show" id="" class="modal is-active modal-new">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-head-title">
          <slot name="header"></slot>
        </div>
      </header>

      <section class="modal-card-body has-text-centered">
        <slot></slot>
        <div class="margin-top-30">
          <button
            class="button hollow-btn"
            data-track="Modal button - Cancel button"
            @click="closeModal"
          >
            CANCEL
          </button>
          <button
            class="button solid-btn"
            data-track="Modal button - Submit button"
            @click="submitModal"
          >{{ submitBtn.text }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalNew',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    submitBtn: {
      type: Object,
      required: true
    },
    closeFn: {
      type: Function,
      required: true
    }
  },
  methods: {
    submitModal () {
      this.submitBtn.fn()
      this.closeFn()
    },
    closeModal () {
      this.closeFn()
    }
  }
}
</script>

<style scoped>
.modal-card {
  max-width: max-content;
  height: auto;
}

.modal-card-head {
  border-top-width: 5px;
  padding-top: 17px;
}

.modal-card-head-title {
  margin-bottom: 3px;
}

.modal-card-body {
  font-size: 12px;
  padding-left: 33px;
  padding-right: 33px;
  padding-bottom: 23px;
}

.hollow-btn, .solid-btn {
  font-size: 12px;
}

.hollow-btn {
  padding-left: 42px;
  padding-right: 41px;
}

.solid-btn {
  padding-right: 20px;
  padding-left: 19px;
  padding-top: 9px;
  margin-left: 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalNew.vue